module.exports = __webpack_public_path__ + "img/responsive crc-06.017c328d.jpg";